<template>
    <div class="field-container cta-field field-checkbox">
        <div class="form-group">
            <div class="form-check" :class="{ 'is-invalid': v.$error, 'is-valid': !v.$error && !v.$invalid }">
                <input ref="valuefield" type="checkbox" :id="field_id" value="1" :disabled="disabled" v-model="input" class="form-check-input" />
                <label class="form-check-label" :for="field_id">{{ form_label }}</label>
            </div>
            <transition name="fade">
                <div class="invalid-feedback" v-if="is_required && !v.required">{{ $t('i18n.fieldIsRequired') }}</div>
            </transition>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        value: {
            type: Boolean,
            default: false,
        },
        v: {
            type: Object,
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
        field_id: {
            type: String,
            required: true,
        },
    },
    computed: {
        form_label: function () {
            return this.field.label;
        },
        form_placeholder: function () {
            return this.field.value ? this.field.value : this.field.placeholder;
        },
        is_required: function () {
            return this.field.required;
        },
        input: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            },
        },
    }
};
</script>